<template>
  <div>
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Devis/Pro forma
        <span class="separator" />
      </h1>
    </b-col>
    <ListeDevisProForma />
  </div>
</template>

<script>
import ListeDevisProForma from "@/components/commandes/ListeDevisProForma.vue";

export default {
  name: "BonsCommandes",
  components: {
    ListeDevisProForma,
  },
};
</script>

<style lang="scss" scoped></style>
